var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import deepMerge from 'deepmerge';
import React from 'react';
import { compileObject, clone } from '../util';
import { compileUrl, handleActionResponse, handleInvalidValidationResult, Refresh$ } from '../services/actions';
import { Container } from '../services/di';
import { renderDynamicComponent } from '../render';
import { ApplicationContext } from '../context';
import { SpecificAction } from '../api';
var DynamicForm = /** @class */ (function (_super) {
    __extends(DynamicForm, _super);
    function DynamicForm(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this._registeredControlPaths = new Set();
        _this.state = {
            loading: false,
            saving: false,
            acceptWarnings: false
        };
        _this.dataState = Container.createDataStateService();
        _this.dataState.setRecord(clone(_this.props.dataState.record));
        return _this;
    }
    DynamicForm.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.control.defaults) {
            var current = this.dataState.record;
            var compiled = compileObject(this.props.control.defaults, this.props.dataState.record, Container.locale);
            var final = deepMerge(compiled, current);
            this.dataState.setRecord(final);
        }
        if (this.props.control.overrides) {
            var current = this.dataState.record;
            var compiled = compileObject(this.props.control.overrides, this.props.dataState.record, Container.locale);
            var final = deepMerge(current, compiled);
            this.dataState.setRecord(final);
        }
        if (this.props.control.validation) {
            if (this.props.control.validation.whenChanges) {
                this.dataState.pathChange
                    .subscribe(function (change) {
                    var some = _this.props.control.validation.whenChanges
                        .some(function (wc) { return change.containsPath(wc); });
                    if (some) {
                        _this.executeRemoteValidation();
                    }
                });
            }
        }
        if (this.context) {
            this.context.broadcast
                .subscribe(function (event) {
                if (event.type == 'SpecificAction' && event.data == SpecificAction.Submit) {
                    _this.onSubmit();
                }
            });
        }
    };
    DynamicForm.prototype.executeRemoteValidation = function () {
        var _this = this;
        Container.http.post(compileUrl(this.props.control.validation.endpoint), this.props.dataState)
            .then(function (result) {
            _this.dataState.validationReset.next();
        }, function (response) {
            _this._handleErrorResult(response);
        });
    };
    DynamicForm.prototype.onSubmit = function () {
        var _this = this;
        this.setState({ saving: true });
        Container.http.post(compileUrl(this.props.control.endpoint, this.props.dataState), __assign(__assign({}, this.dataState.record), { $acceptWarnings: this.state.acceptWarnings }))
            .then(function (result) {
            // TODO
            if (result.$action) {
                return handleActionResponse(result.$action);
            }
            _this.dataState.validationReset.next();
            _this.dataState.setRecord(result);
            _this.setState({
                acceptWarnings: true,
                saving: false
            });
            Refresh$.next();
        }, function (response) {
            _this.setState({
                saving: false
            });
            _this._handleErrorResult(response);
        });
    };
    DynamicForm.prototype.registerControlPaths = function () {
        var _this = this;
        var walk = function (control) {
            if (control.path) {
                _this._registeredControlPaths.add(control.path);
            }
            if (control.children) {
                control.children.forEach(function (child) { return walk(child); });
            }
        };
        walk(this.props.control);
    };
    DynamicForm.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null, this.props.control.children
            .map(function (child, index) { return renderDynamicComponent(index, child, _this.dataState); }));
    };
    DynamicForm.prototype._handleErrorResult = function (response) {
        var _this = this;
        this.dataState.validationReset.next();
        if (response.status == 400) {
            var validationErrors = response.serverError.errors;
            var modelErrors = response.serverError.errors
                .filter(function (e) { return e.path == null || _this._registeredControlPaths.has(e.path) == false; });
            if (modelErrors.length > 0) {
                handleInvalidValidationResult(modelErrors);
            }
            this.dataState.emitValidationErrors(validationErrors);
        }
        else {
            alert('Uložení se nepovedlo');
            throw response;
        }
    };
    DynamicForm.contextType = ApplicationContext;
    return DynamicForm;
}(React.Component));
export default DynamicForm;
//# sourceMappingURL=Form.js.map